module.exports = __webpack_public_path__ + "img/list22.01ed38c9.jpg";